export const queryPhraseRegExp = /^".*"$/;

export const DateRangeLifetime = {
  start: 1845,
  end: 1917,
};

export const yearCompilations = 1918;

export const Order = {
  wrel: "wrel",
  seq: "seq",
  rel: "rel",
  date: "date",
  minusDate: "-date",
};

export const Snippet = {
  REF: "ref",
  SHORT: "short",
  LONG: "long",
  FULL: "full",
};

export const QUERY_TYPE = {
  EXACT: "exact",
  PREFER_EXACT: "prefer_exact",
  STEMMED: "stemmed",
  EXCLUDE_EXACT: "exclude_exact",
};

export const queryTypeOptions = [
  { key: QUERY_TYPE.PREFER_EXACT, label: "queryTypePreferExact" },
  { key: QUERY_TYPE.EXACT, label: "queryTypeExact" },
  { key: QUERY_TYPE.EXCLUDE_EXACT, label: "queryTypeStemmed" },
  // { key: QUERY_TYPE.STEMMED, label: "queryTypeStemmed" },
  // { key: QUERY_TYPE.EXCLUDE_EXACT, label: "excludeExact" },
];

export const orderOptions = [
  { key: Order.wrel, label: "weightedrelevancy" },
  { key: Order.seq, label: "booksequence" },
  { key: Order.rel, label: "relevancy" },
  { key: Order.date, label: "earliestfirst" },
  { key: Order.minusDate, label: "latestfirst" },
];

export const orderOptionsExcludedLanding = [Order.rel, Order.date, Order.minusDate];

export const limitOptions = [
  { key: 10, label: "10" },
  { key: 25, label: "25" },
  { key: 50, label: "50" },
];

export const snippetOptions = [
  { key: Snippet.REF, label: "reference" },
  { key: Snippet.SHORT, label: "short" },
  { key: Snippet.LONG, label: "long" },
  { key: Snippet.FULL, label: "paragraph" },
];

export const searchGroups = {
  egwwritings: "egw",
  bible: "bible",
  apl: "apl",
  reference: "reference",
};

export const Period = {
  both: "both",
  all: "all",
  lifetime: "lifetime",
  compilations: "compilations",
  myBible: "mybible",
  bible: "bible", // Seems very unnecessary.
  apl: "apl",
  dictionary: "dictionary",
};

// "custom" option is absent in the Textapp. There is no Tree menu which this period related to.
export const PeriodWithCustom = { ...Period, custom: "custom" };

export const Periods = Object.values(Period);

export const DictionarySearchType = {
  TEXT: "false",
  HEADINGS: "true",
  HEADINGS_EXACT: "exact",
};

export const DictionarySearchTypeOptions = [
  { id: DictionarySearchType.HEADINGS_EXACT, label: "searchExactHeadings" },
  { id: DictionarySearchType.HEADINGS, label: "searchHeadings" },
  { id: DictionarySearchType.TEXT, label: "searchText" },
];

export const PeriodDefault = Period.both;

export const SEARCH_SNIPPET_DEFAULT = Snippet.SHORT;

export const LOCAL_SEARCH_SNIPPET_DEFAULT = Snippet.LONG;

export const OrderDefault = Order.wrel;

export const LocalOrderDefault = Order.rel;

export const DictionarySearchTypeDefault = DictionarySearchType.HEADINGS_EXACT;

export const QueryTypeDefault = QUERY_TYPE.PREFER_EXACT;

export const Collection = {
  ALL: "all",
  EGW: "egwwritings",
  BIBLE: "bible",
  REFERENCE: "reference",
  APL: "apl",
};

export const CollectionAllKey = Collection.ALL;

export const Collections = Object.values(Collection);

export const CollectionDefault = Collection.EGW;

export const CollectionName = {
  EGW: "egwCollection",
  ALL: "allCollection",
  COMPILATIONS: "compilations",
  LIFETIME: "lifetime",
  APL: "adventistpioneerlibrary",
  MY_BIBLE: "myBible",
  DICTIONARY: "dictionary",
};

export const collectionOptions = [
  { key: Collection.ALL, label: CollectionName.ALL },
  { key: Collection.EGW, label: CollectionName.EGW },
  { key: Collection.BIBLE, label: "bible" },
  { key: Collection.APL, label: CollectionName.APL },
  { key: Collection.REFERENCE, label: "reference" },
];

export const periodOptions = [
  { key: Period.both, label: CollectionName.EGW },
  { key: Period.all, label: CollectionName.ALL },
  { key: Period.lifetime, label: CollectionName.LIFETIME },
  { key: Period.compilations, label: CollectionName.COMPILATIONS },
  { key: Period.apl, label: CollectionName.APL },
  { key: Period.myBible, label: CollectionName.MY_BIBLE },
  { key: Period.dictionary, label: CollectionName.DICTIONARY },
];

export const SEARCH_TOTAL_MAX = 99999;

export const FOLDERS_IDS_APL = [15];

export const SearchItemType = {
  SHORTCUT: "shortcut",
  SUGGESTION: "suggestion",
  TRANSLATIONS: "translations",
  CORRECTION: "correction",
  SYNONYM: "synonym",
  RECENT: "recent",
  WORD: "word",
  AUTOCOMPLETE: "autocomplete",
  RECENT_MORE: "recent-more",
};

export const dateRangeSearchAll = Period.both;

export const dateRangeInitial = [
  { id: Period.lifetime, label: "lifetime" },
  { id: Period.compilations, label: "compilations" },
  { id: Period.both, label: "search_all" },
];

export const monthNamesInitial = [
  "january",
  "february",
  "march",
  "april",
  "may",
  "june",
  "july",
  "august",
  "september",
  "october",
  "november",
  "december",
];

export const AdvSearchType = {
  book: "book",
  periodicals: "periodicals",
  ltms: "ltms",
  topical: "topical",
  scripture: "scripture",
  apl: "apl",
  reference: "reference",
  bible: "bible",
  commentary: "commentary",
  dictionary: "dictionary",
};

export const advSearchTypes = Object.values(AdvSearchType);

export const SearchType = {
  ...AdvSearchType,
  basic: "basic",
  bookCode: "pubnr",
  related: "related",
};

export const SearchTypeDefault = SearchType.basic;

export const SearchTypes = Object.values(SearchType);

export const ViewTabResultsRightPanel = {
  answers: "answers",
  faq: "faq",
  related: "related",
  featured: "featured",
  text: "text",
  translations: "translations",
};

export const ViewTabResultsRightPanelDefault = ViewTabResultsRightPanel.text;

const extrasCommon = ["type", "queryType", "order", "snippet", "period"];

export const mapSearchTypeToNamesExtras = {
  [SearchType.basic]: [...extrasCommon, "pubnr", "bookCode", "dictionarySearchType"],
  [SearchType.related]: [...extrasCommon, "section"],
  [SearchType.bookCode]: extrasCommon,
  [SearchType.dictionary]: [...extrasCommon, "dictionarySearchType"],
  // Adv types
  [SearchType.book]: [
    ...extrasCommon,
    "lang",
    "pubnr",
    "bookCode",
    "bookpage",
    "paragraph",
    "daterange",
    "collections",
  ],
  [SearchType.periodicals]: [
    ...extrasCommon,
    "daterange",
    "start_year",
    "end_year",
    "pubnr",
    "bookCode",
    "paragraph",
    "year",
    "month",
    "day",
  ],
  [SearchType.ltms]: [
    ...extrasCommon,
    "subtype",
    "number",
    "year",
    "place",
    "addressee",
    "start_year",
    "end_year",
  ],
  [SearchType.topical]: [...extrasCommon, "headings_only"],
  [SearchType.scripture]: [...extrasCommon, "book", "chapter"],
  [SearchType.apl]: [
    ...extrasCommon,
    "subtype",
    "pubnr",
    "bookCode",
    "bookpage",
    "paragraph",
    "start_year",
    "end_year",
    "date",
    "folder", // author
  ],
  [SearchType.reference]: [
    ...extrasCommon,
    "collection",
    "pubnr",
    "bookCode",
    "bookpage",
    "paragraph",
  ],
  [SearchType.bible]: [...extrasCommon, "lang", "pubnr", "bookCode", "book", "chapter", "verse"],
  [SearchType.commentary]: [...extrasCommon, "pubnr", "bookCode", "book", "chapter", "verse"],
};

export const dictionaryAllFilterKey = "all";

export const dictionaryNWANDFilterKey = 1843; // "Noah Webster’s 1828 Dictionary (NWAD)"

export const dictionaryDefaultFilter = { key: dictionaryAllFilterKey, label: "All Dictionaries" };

export const isRestricted = (value, max) => value > (max || SEARCH_TOTAL_MAX);

export const SearchListType = {
  OMSK: "omsk_search",
  BOOK: "book_search",
  PHRASE: "phrase_search",
  SUGGESTION: "suggestion_search",
  DEFAULT: "default",
  ANSWER: "answer",
  FAQ: "faq",
  AI: "ai",
};

export const facetsKeysOmsk = ["egw_search:003", "egw_dictionary:002"];
export const facetsKeysBook = ["egw_search:002"];
export const facetsKeysPhrase = ["egw_phrase:000"];
export const facetsKeysSuggestion = ["egw_search:009"];
export const facetsKeysAI = ["egw_ai"];
export const searchParamsAI = { extras: { section: facetsKeysAI[0] } };

export const escapeHtml = (html) => {
  return html.replace(/</g, "&lt;").replace(/>/g, "&gt;");
};
